import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

import PageHeading from "../../../components/common/PageHeading";
import Footer from "../../../components/common/Footer";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Radio,
  Row,
  Select,
  Space,
} from "antd";

import {
  managementCompanies,
  propertyEndReasoon,
} from "../../../utils/property";

import "./EndManagement.css";
import { useParams } from "react-router-dom";

const EndManagementRightBar = [
  RightBarMethod(
    "REPORTS",
    "t1",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("General Ledger", "1", "", "", ""),
      RightBarMethod("Financial Diagnostics", "2", "", "", ""),
    ]
  ),
  RightBarMethod(
    "HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Closing a Property", "3", "", "", "")]
  ),
  RightBarMethod("LETTERS", "t3", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("Letter Templates", "18", "", "", ""),
  ]),
];

function EndManagement() {
  const [value, setValue] = useState("");
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const { id } = useParams();

  const handleFormSubmit = async (values) => {
    const companiesRef = collection(db, "companies");
    const propertyRef = doc(companiesRef, "sayeagle", "properties", id);

    const propertyManagement = {
      "propertyInformation.managementEndDate": values.managementEndDate.format("YYYY-MM-DD"),
      "propertyInformation.managementEndReason": values.managementEndReason,
      "propertyInformation.isPropertyManagedByOtherCompany": values.isPMBOC,
      "propertyInformation.newManagementCompany": values.newManagementCompany
        ? values.newManagementCompany
        : "",
    };
    try {
      await updateDoc(propertyRef, propertyManagement);
      toast.success("Property management end successfully successfully");
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const onFinishFailed = (err) => {
    console.log(err);
  };
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="End Management" />
          <div className="end-management">
            <Form
              layout="vertical"
              onFinish={handleFormSubmit}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Card title="Property">
                    <Row gutter={[0, 16]}>
                      <Col span={24}>
                        <p className="silver-text">Property</p>
                      </Col>
                      <Col span={24}>
                        <p className="onclick-text">
                          test 2 1800 canyon park circle, edmond, OK 73013
                        </p>
                      </Col>
                      <Col span={24}>
                        <Row gutter={[24, 0]}>
                          <Col span={8}>
                            <Form.Item
                              label="Management End Date"
                              required
                              name="managementEndDate"
                              rules={[{required: true, message: "Can't be blank"}]}
                            >
                              <DatePicker />
                            </Form.Item>
                          </Col>
                          <Col span={8}>
                            <Form.Item
                              label="Management End Reason"
                              required
                              name="managementEndReason"
                              rules={[{required: true, message: "Can't be blank"}]}
                            >
                              <Select
                                options={propertyEndReasoon}
                                placeholder="Select..."
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="New Management Company">
                    <Row>
                      <Col span={24}>
                        <Form.Item
                          label="Will this property be managed by a new management company?"
                          required
                          name="isPMBOC"
                          rules={[{required: true, message: "Can't be blank"}]}
                        >
                          <Radio.Group onChange={onChange} value={value}>
                            <Space direction="vertical">
                              <Radio value="yes">Yes</Radio>
                              <Radio value="no">No / I don't know</Radio>
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {value === "yes" ? (
                        <Col span={8}>
                          <Form.Item
                            label="New Management Company"
                            required
                            name="newManagementCompany"
                            rules={[{required: true, message: "Can't be blank"}]}
                          >
                            <Select options={managementCompanies} />
                          </Form.Item>
                          <p className="onclick-text">
                              Add a new management company
                            </p>
                        </Col>
                      ) : null}
                    </Row>
                  </Card>
                </Col>
                <Col span={24}>
                  <Button type="primary" htmlType="submit">
                    Continue
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={EndManagementRightBar} />
      </div>
    </>
  );
}

export default EndManagement;
